<template>
  <v-sheet width="100%" color="transparent">
    <MediaManagerWrapper
      class="d-flex flex-column justify-center align-center"
      :initialImages="images"
      :readOnly="readOnly"
      @change="$emit('change', $event)"
    >
      <template
        slot-scope="{ selectFile, isDraggingFile, showImage, removeImage }"
      >
        <v-sheet
          v-if="!onlyThumbnails"
          class="main-section"
          height="258"
          width="100%"
        >
          <MainImage
            v-if="mainImage"
            :image="mainImage"
            :readOnly="readOnly"
            @show="showImage(0)"
            @remove="removeImage(0)"
          />

          <MainUploader
            v-if="!mainImage && !readOnly"
            :isDraggingFile="isDraggingFile"
            @select="selectFile"
          />
        </v-sheet>

        <v-spacer
          v-if="!onlyThumbnails"
          class="flex-grow-0"
          :class="{ 'mt-4': !readOnly, 'mt-2': readOnly }"
        />

        <v-sheet
          class="d-flex justify-start flex-wrap"
          width="100%"
          color="transparent"
        >
          <ThumbnailImage
            v-for="(image, index) in thumbnailImages"
            class="mb-2"
            :class="{ 'me-3': index !== limit - MAIN_IMAGE_OFFSET - 1 }"
            :key="image.id"
            :image="image"
            :readOnly="readOnly"
            :small="Boolean(mainImage || smallThumbnails)"
            @show="showImage(index + MAIN_IMAGE_OFFSET)"
            @remove="removeImage(index + MAIN_IMAGE_OFFSET)"
          />

          <ThumbnailUploader
            v-if="
              !readOnly &&
                !hasReachedLimit &&
                (onlyThumbnails || images.length > 0)
            "
            class="mb-2"
            :isDraggingFile="isDraggingFile"
            :small="Boolean(mainImage || smallThumbnails)"
            :tooltip="$t('common.upload_image')"
            @select="selectFile"
          />
        </v-sheet>
      </template>
    </MediaManagerWrapper>
  </v-sheet>
</template>

<script>
import MediaManagerWrapper from '@/components/utils/MediaManagementWrapper/MediaManagementWrapper.vue'

import MainUploader from './MainUploader.vue'
import ThumbnailUploader from './ThumbnailUploader.vue'
import MainImage from './MainImage.vue'
import ThumbnailImage from './ThumbnailImage.vue'

export default {
  name: 'MediaContainer',

  components: {
    MediaManagerWrapper,
    MainUploader,
    ThumbnailUploader,
    MainImage,
    ThumbnailImage,
  },

  props: {
    allowMultipleSelect: Boolean,

    readOnly: Boolean,

    images: {
      type: Array,
      default: () => [],
    },

    maxImages: Number,

    onlyThumbnails: {
      type: Boolean,
      default: false,
    },

    smallThumbnails: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      MAIN_IMAGE_OFFSET: this.onlyThumbnails ? 0 : 1,
    }
  },

  computed: {
    limit() {
      return this.maxImages ?? this.$constants.images.defaultLimit
    },

    mainImage() {
      if (this.onlyThumbnails) return null
      return this.images?.[0]
    },

    thumbnailImages() {
      if (this.onlyThumbnails) return this.images
      return this.images.slice(1) ?? []
    },

    hasReachedLimit() {
      return this.images.length >= this.limit
    },
  },
}
</script>

<style lang="scss" scoped>
.main-section {
  position: relative;
}
</style>
